import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { Specialty } from '../model/specialty';
import { BaseService } from './shared/base.service';


@Injectable({
  providedIn: 'root'
})
export class SpecialtyService {

  constructor(private baseService: BaseService){}

  getSpecialties(): Observable<Specialty[]> {
    return this.baseService.get<Specialty[]>(`Common/GetSpecialties`);
   }
}
